import { ExGetterTree } from "vuex";
import { State, Getters } from "./types";
import {
  isRecruitmentEventType,
  isCompetitorEventType,
  isStudentEventType
} from "@/helpers/type-helper";

const getters: ExGetterTree<State, Getters> = {
  getSelectedRecruitmentEvent(state) {
    if (!isRecruitmentEventType(state.selectedEvent)) {
      return;
    }
    return state.selectedEvent;
  },
  getSelectedCompetitorEvent(state) {
    if (!isCompetitorEventType(state.selectedEvent)) {
      return;
    }
    return state.selectedEvent;
  },
  getSelectedStudentEvent(state) {
    if (!isStudentEventType(state.selectedEvent)) {
      return;
    }
    return state.selectedEvent;
  }
};

export default getters;
